module.exports = __webpack_public_path__ + "img/1.29cb8e95.jpg";